import React from 'react'
import classNames from 'classnames'
import TextareaAutoSize from 'react-textarea-autosize'

import type { InputProps } from '../Input/Input'

export type TextareaProps = Omit<
  React.HTMLProps<HTMLTextAreaElement>,
  'size'
> & {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  autoSize?: boolean
  minRows?: number
  maxRows?: number
  ref?: React.Ref<HTMLTextAreaElement>
} & Pick<
    InputProps,
    'size' | 'wrapperClassName' | 'inputClassName' | 'hasError'
  >

export function Textarea({
  className,
  inputClassName,
  wrapperClassName,
  autoSize,
  size = 'large',
  hasError,
  ref,
  ...props
}: TextareaProps) {
  const Component = autoSize ? TextareaAutoSize : 'textarea'
  return (
    <Component
      {...props}
      // @ts-expect-error: TextareaAutoSize have mis-typed style prop
      style={props.style}
      ref={ref}
      className={classNames(
        'width-full padding-horizontal-12  shade-05 background-shade-100 placeholder-shade-20 scrollable',
        'border-small radius-large ',
        {
          'padding-vertical-12 font-size-large line-height-large':
            size === 'large',
          'padding-vertical-8 font-size-normal line-height-large':
            size === 'medium',
          'padding-vertical-4 font-size-normal line-height-large':
            size === 'small',
        },
        {
          'border-red border-red-on-focus': hasError,
          'border-shade-40 border-shade-30-on-focus': !hasError,
        },
        className,
        inputClassName,
        wrapperClassName
      )}
    />
  )
}
